import join from 'url-join';

import { IS_SSR } from '../constants';
import { getENV } from './env';

export function getCWEA() {
    const { NEXT_PUBLIC_CWEA_PROXY_URL_CA, NEXT_PUBLIC_CWEA_PROXY_URL_US, NEXT_PUBLIC_EPHEMERAL, NEXT_PUBLIC_LOCALE } =
        getENV();

    if (!IS_SSR && NEXT_PUBLIC_EPHEMERAL) {
        return join(location.origin, '/api/cwea');
    }

    const config = { 'en-US': NEXT_PUBLIC_CWEA_PROXY_URL_US, 'en-CA': NEXT_PUBLIC_CWEA_PROXY_URL_CA };
    return config[NEXT_PUBLIC_LOCALE];
}
